/**
 * @flow
 * @relayHash 4cb6938ee08f544eff7059853fe48440
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SowingCreateInput = {|
  where?: ?string,
  notes?: ?string,
  location?: ?any,
  species?: ?$ReadOnlyArray<?string>,
  name?: ?string,
  email?: ?string,
  clientMutationId?: ?string,
  revisionMessage?: ?string,
|};
export type SowingAddMutationVariables = {|
  input: SowingCreateInput
|};
export type SowingAddMutationResponse = {|
  +sowingCreate: ?{|
    +sowing: ?{|
      +node: ?{|
        +id: string
      |}
    |},
    +errors: ?$ReadOnlyArray<?{|
      +code: ?string,
      +location: ?string,
      +message: string,
    |}>,
  |}
|};
export type SowingAddMutation = {|
  variables: SowingAddMutationVariables,
  response: SowingAddMutationResponse,
|};
*/


/*
mutation SowingAddMutation(
  $input: SowingCreateInput!
) {
  sowingCreate(input: $input) {
    sowing {
      node {
        id
      }
    }
    errors {
      code
      location
      message
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "SowingCreateInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "sowingCreate",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SowingCreatePayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "sowing",
        "storageKey": null,
        "args": null,
        "concreteType": "SowingEdge",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Sowing",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "errors",
        "storageKey": null,
        "args": null,
        "concreteType": "Error",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "code",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "location",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "message",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "SowingAddMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "SowingAddMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "SowingAddMutation",
    "id": null,
    "text": "mutation SowingAddMutation(\n  $input: SowingCreateInput!\n) {\n  sowingCreate(input: $input) {\n    sowing {\n      node {\n        id\n      }\n    }\n    errors {\n      code\n      location\n      message\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f0376d20ed1b339c1f039739d4321be6';
module.exports = node;
